import React from 'react';
import '../../../../assests/css/admin/DisputeManagement/DisputerCards/DisputeCards.css';

const DisputeCards = ({ stats }) => {
  return (
    <div className="Dispute-Admin-Dispute-cards-grid">
      <div className="Dispute-Admin-Dispute-card Dispute-Admin-Dispute-card-animate">
        <div className="Dispute-Admin-Dispute-card-label">Total Open</div>
        <div className="Dispute-Admin-Dispute-card-value">{stats.totalOpen.value}</div>
        <div className={`Dispute-Admin-Dispute-card-change ${stats.totalOpen.isPositive ? 'positive' : 'negative'}`}>
          {stats.totalOpen.change}
        </div>
      </div>
      
      <div className="Dispute-Admin-Dispute-card Dispute-Admin-Dispute-card-animate">
        <div className="Dispute-Admin-Dispute-card-label">Pending Admin</div>
        <div className="Dispute-Admin-Dispute-card-value">{stats.pendingAdmin.value}</div>
        <div className={`Dispute-Admin-Dispute-card-change ${stats.pendingAdmin.isPositive ? 'positive' : 'negative'}`}>
          {stats.pendingAdmin.change}
        </div>
      </div>
      
      <div className="Dispute-Admin-Dispute-card Dispute-Admin-Dispute-card-animate">
        <div className="Dispute-Admin-Dispute-card-label">Resolved</div>
        <div className="Dispute-Admin-Dispute-card-value">{stats.resolved.value}</div>
        <div className={`Dispute-Admin-Dispute-card-change ${stats.resolved.isPositive ? 'positive' : 'negative'}`}>
          {stats.resolved.change}
        </div>
      </div>
      
      <div className="Dispute-Admin-Dispute-card Dispute-Admin-Dispute-card-animate">
        <div className="Dispute-Admin-Dispute-card-label">Escalated</div>
        <div className="Dispute-Admin-Dispute-card-value">{stats.escalated.value}</div>
        <div className={`Dispute-Admin-Dispute-card-change ${stats.escalated.isPositive ? 'positive' : 'negative'}`}>
          {stats.escalated.change}
        </div>
      </div>
    </div>
  );
};

export default DisputeCards;